export enum OrderStates {
  NEW,
  PAYMENT_PROCESSING,
  PAYMENT_FAILED,
  PAID,
}

export type ResultTypes = 'NOT_SELECTED' | 'PERSON_CONSULTATION' | 'PHONE_CONSULTATION' | 'EMAIL_CONSULTATION';

export interface Order {
  name?: string;
  email?: string;
  phone?: string;
  resultType?: ResultTypes;
  state?: OrderStates;
  payment?: string;
  created?: string;
}

export interface OrderWithId extends Order { id: string }

export interface TextInterface {
  title: string;
  paragraphs: string[];
}

export interface TextsInterface {
  candidate: {
    info: TextInterface;
    pricing: TextInterface;
    consultation: TextInterface;
  }
  company: {
    contact: TextInterface;
    info: TextInterface;
    pricing: TextInterface;
  }
  home: {
    home: TextInterface;
  };
}
